import { ReactNode } from 'react';
// @mui
import { alpha, styled } from '@mui/material/styles';
import {
  LinkProps,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  ListItemButtonProps,
} from '@mui/material';
// config
import { ICON, NAVBAR } from 'src/config';
import { BRAND } from 'src/theme/palette';

// ----------------------------------------------------------------------

type IProps = LinkProps & ListItemButtonProps;

export interface ListItemStyleProps extends IProps {
  component?: ReactNode;
  to?: string;
  activeRoot?: boolean;
  activeSub?: boolean;
  subItem?: boolean;
  roles?: string[];
}

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'activeRoot' && prop !== 'activeSub' && prop !== 'subItem',
})<ListItemStyleProps>(({ activeRoot, activeSub, subItem, theme }) => ({
  ...theme.typography.body2,
  position: 'relative',
  height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT,
  textTransform: 'capitalize',
  fontSize: '1rem !important',
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1.5),
  color: theme.palette.grey[400],
  borderRadius: theme.shape.borderRadius,
  // Focus state for keyboard navigation
  '&:focus-visible': {
    outline: `2px solid #739272`,
    outlineOffset: 2,
  },
  // Hover state
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.46)',
    opacity: 1,
  },
  // activeRoot
  ...(activeRoot && {
    ...theme.typography.subtitle2,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    fontWeight: 600,
    color: BRAND.white,
    boxShadow: '0 0 1px 1px rgba(0, 0, 0, 0.5)',
    opacity: 1,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },
  }),
  // activeSub
  ...(activeSub && {
    ...theme.typography.subtitle2,
    color: BRAND.white,
    backgroundColor: 'rgba(53, 57, 53, 0.16)',
    opacity: 1,
    '&:hover': {
      backgroundColor: 'rgba(49, 48, 48, 0.24)',
    },
  }),
  // subItem
  ...(subItem && {
    height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
  }),
}));

interface ListItemTextStyleProps extends ListItemButtonProps {
  isCollapse?: boolean;
}

export const ListItemTextStyle = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'isCollapse',
})<ListItemTextStyleProps>(({ isCollapse, theme }) => ({
  whiteSpace: 'nowrap',
  transition: theme.transitions.create(['width', 'opacity'], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(isCollapse && {
    width: 0,
    opacity: 0,
  }),
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: ICON.NAVBAR_ITEM,
  height: ICON.NAVBAR_ITEM,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': { width: '100%', height: '100%' },
});
